import { Skeleton } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import AuthLayout from "./AuthLayout";

const AdminLayout = (props) => {
  const { isAdmin } = useSelector((state) => state.auth);
  if (isAdmin === null) {
    return (
      <AuthLayout needsAdmin={true}>
        <Skeleton active />
      </AuthLayout>
    );
  }
  if (isAdmin === false) {
    return <Redirect to="/home-sso" />;
  }
  return <AuthLayout needsAdmin={true}>{props.children}</AuthLayout>;
};

export default AdminLayout;
